<section
  id="services"
  class="services bg-blue-50 p-4 md:p-8 m-1 md:m-8"
  style="border-radius: 30px;"
>
  <div class="px-4 md:px-12">
    <h2
      class="font-clashg text-lg text-left mt-4 uppercase font-bold text-DarkBlue"
    >
      Servicios
    </h2>
    <p
      class="font-clashg relative text-2xl md:text-5xl mt-2 font-medium text-left"
    >
      Descubre Todo En Lo Que Podemos Ayudarte.
    </p>
    <p class="text-lg my-4 text-Gray">
      Ofrecemos una amplia gama de servicios especializados en Higiene y
      Seguridad en el Trabajo, consultoría ambiental y servicios de ingeniería.
      Nuestro enfoque integral garantiza que cada cliente reciba soluciones
      personalizadas y de alta calidad.
    </p>

    <!-- Grid de 1x1 en móvil, 2x2 en tablet, 3x3 en desktop -->
    <div
      class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mt-8"
    >
      <!-- Servicio 1 -->
      <div>
        <img
          src="/seguridad-e-higiene.jpg"
          alt="Servicio 1"
          class="w-full h-64 md:h-48 object-cover mb-4 rounded-md"
        />
        <h3 class="font-clashg relative text-xl md-2 font-medium text-left">
          Consultoría de Higiene y Seguridad en el Trabajo
        </h3>
        <p class="text-Gray text-md">
          Asesoría con personal calificado y matriculado de última
          generación,para la elaboración de la solución específica del problema
          de cada Cliente.
        </p>
      </div>

      <!-- Servicio 2 -->
      <div>
        <img
          src="/extinsion-fuego.jpg"
          alt="Servicio 2"
          class="w-full h-64 md:h-48 object-cover mb-4 rounded-md"
        />
        <h3 class="font-clashg relative text-xl md-2 font-medium text-left">
          Simulacros de Evacuación y de Extinción de Incendios
        </h3>
        <p class="text-Gray text-md">
          Se realizan simulacros en cada ambiente de trabajo teniendo en cuenta
          el entorno y los distintas clases de fuegos.
        </p>
      </div>

      <!-- Servicio 3 -->
      <div>
        <img
          src="/planes-seguridad.jpg"
          alt="Servicio 3"
          class="w-full h-64 md:h-48 object-cover mb-4 rounded-md"
        />
        <h3 class="font-clashg relative text-xl md-2 font-medium text-left">
          Confección de Programas y Planes de Seguridad
        </h3>
        <p class="text-Gray text-md">
          Se realizan la confeccion de programas y planes de seguridad segun Ley
          N° 19587.
        </p>
      </div>

      <!-- Servicio 4 -->
      <div>
        <img
          src="/evaluaciones-auditorias.jpg"
          alt="Servicio 4"
          class="w-full h-64 md:h-48 object-cover mb-4 rounded-md"
        />
        <h3 class="font-clashg relative text-xl md-2 font-medium text-left">
          Estudios, Evaluaciones y Auditorías de Control y Verificación
        </h3>
        <p class="text-Gray text-md">
          Realizamos auditorias, evaluaciones y estudios para cada tipo de
          empresa
        </p>
      </div>

      <!-- Servicio 5 -->
      <div>
        <img
          src="/situacion-instalaciones.jpg"
          alt="Servicio 5"
          class="w-full h-64 md:h-48 object-cover mb-4 rounded-md"
        />
        <h3 class="font-clashg relative text-xl md-2 font-medium text-left">
          Situación de Instalaciones y Riesgos Potenciales
        </h3>
        <p class="text-Gray text-md">
          Es un servicio que evalúa el estado de las instalaciones y detecta
          riesgos que puedan afectar la seguridad y eficiencia operativa,
          ayudando a prevenir problemas críticos y optimizar la gestión de
          infraestructura.
        </p>
      </div>

      <!-- Servicio 6 -->
      <div>
        <img
          src="/capacitacion.jpeg"
          alt="Servicio 6"
          class="w-full h-64 md:h-48 object-cover mb-4 rounded-md"
        />
        <h3 class="font-clashg relative text-xl md-2 font-medium text-left">
          Formación y Entrenamiento del Personal
        </h3>
        <p class="text-Gray text-md">
          Dictados de cursos de capacitación en temas de Higiene y Seguridad.
        </p>
      </div>

      <!-- Servicio 7 -->
      <div>
        <img
          src="/relevamiento-mediciones.jpg"
          alt="Servicio 7"
          class="w-full h-64 md:h-48 object-cover mb-4 rounded-md"
        />
        <h3 class="font-clashg relative text-xl md-2 font-medium text-left">
          Relevamiento y Mediciones de Agentes de Riesgo
        </h3>
        <p class="text-Gray text-md">
          Medición para establecer los niveles de Puestas a Tierra, Iluminación,
          Medición de nivel de ruidos y Carga Térmica. Medicion de polvo en
          suspención.
        </p>
      </div>

      <!-- Servicio 8 -->
      <div>
        <img
          src="/estudios-ergonomicos.jpg"
          alt="Servicio 8"
          class="w-full h-64 md:h-48 object-cover mb-4 rounded-md"
        />
        <h3 class="font-clashg relative text-xl md-2 font-medium text-left">
          Estudios Ergonómicos
        </h3>
        <p class="text-Gray text-md">
          Evaluamos condiciones ergonómicas para optimizar el bienestar de los
          trabajadores y reducir riesgos de lesiones.
        </p>
      </div>

      <!-- Servicio 9 -->
      <div>
        <img
          src="/gestion-logistica.jpg"
          alt="Servicio 9"
          class="w-full h-64 md:h-48 object-cover mb-4 rounded-md"
        />
        <h3 class="font-clashg relative text-xl md-2 font-medium text-left">
          Sistema de Gestión
        </h3>
        <p class="text-Gray text-md">
          Implementamos sistemas de gestión de seguridad laboral y ambiental,
          alineados con las normativas internacionales.
        </p>
      </div>
    </div>
  </div>
</section>

<section class="mt-12 md:mt-16">
  <div>
    <h2
      class="font-clashg text-lg text-center mt-4 uppercase font-bold text-DarkBlue"
    >
      Lo Que Nos Distingue
    </h2>
  </div>

  <!-- Contenedor para las tarjetas, ajustado para móvil -->
  <div class="flex w-full justify-center flex-wrap my-6 gap-x-5 gap-y-3">
    <!-- Tarjeta 1 -->
    <div
      class="bg-Black flex items-center justify-center py-3 px-6 md:py-3 md:px-6 w-max text-white rounded-xl border border-gray-300"
    >
      <img
        src={"/Icons/shield.svg"}
        alt="Logo 1"
        class="h-6 w-6 md:h-8 md:w-8 mr-4"
      />
      <div>
        <p class="font-clashg font-medium text-md md:text-lg">Calidad</p>
      </div>
    </div>

    <!-- Tarjeta 2 -->
    <div
      class="bg-Black flex items-center justify-center py-3 px-6 md:py-3 md:px-6 w-max text-white rounded-xl border border-gray-300"
    >
      <img
        src={"/Icons/stopwatch.svg"}
        alt="Logo 2"
        class="h-6 w-6 md:h-8 md:w-8 mr-4"
      />
      <div>
        <p class="font-clashg font-medium text-md md:text-lg">
          Puntualidad En Los Servicios
        </p>
      </div>
    </div>

    <!-- Tarjeta 3 -->
    <div
      class="bg-Black flex items-center justify-center py-3 px-6 md:py-3 md:px-6 w-max text-white rounded-xl border border-gray-300"
    >
      <img
        src={"/Icons/money.svg"}
        alt="Logo 3"
        class="h-6 w-6 md:h-8 md:w-8 mr-4"
      />
      <div>
        <p class="font-clashg font-medium text-md md:text-lg">
          Precios Competitivos
        </p>
      </div>
    </div>

    <!-- Tarjeta 4 -->
    <div
      class="bg-Black flex items-center justify-center py-3 px-6 md:py-3 md:px-6 w-max text-white rounded-xl border border-gray-300"
    >
      <img
        src={"/Icons/terminal.svg"}
        alt="Logo 4"
        class="h-6 w-6 md:h-8 md:w-8 mr-4"
      />
      <div>
        <p class="font-clashg font-medium text-md md:text-lg">
          Permanente Avance Tecnológico
        </p>
      </div>
    </div>
  </div>
</section>
